export interface TickerItem {
  time: string;
  text: string;
  tag: string;
}

export const tickerItems: TickerItem[] = [
  { time: "09:12", text: "「每日速报」入口新增 8 条，已并入推荐位", tag: "更新" },
  { time: "09:40", text: "分类专区「老瓜回顾」合集补充归档说明", tag: "合集" },
  { time: "10:05", text: "导航站榜单按近 24 小时热度重排前 10", tag: "榜单" },
  { time: "10:33", text: "「图集精选」入口校验完成，暂无可访问异常", tag: "校验" },
  { time: "11:02", text: "汇总页新增「综艺八卦 / 影视爆料」两个分区", tag: "分类" },
  { time: "11:47", text: "今日已归档冷门合集 5 个，支持按时间挑看", tag: "归档" },
  { time: "12:15", text: "入口列表排序新增「更新新鲜度」维度", tag: "功能" },
  { time: "13:08", text: "移动端入口卡片改为单列，点开更顺手", tag: "适配" },
];